import * as React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.eligibleForIncentiveTrip');
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          {tt(
            'description',
            generateComponentCallback({
              component: (
                <Text variant="heading">
                  Eligible for OPTA
                  <Text variant="small">{'VIA '}</Text>
                  Incentive Trip 2024.
                </Text>
              ),
            }),
          )}
        </Gutter>
      </View>
      <Gutter>
        <View style={styles.bonusProgressBar}>
          <View style={styles.bonusProgressBarSection}>
            <LoadingBox style={styles.loadingBoxDate} />
            <LoadingBox style={styles.loadingBoxProgressBarMoneyEarned} />
          </View>
          <LoadingBox style={styles.loadingBoxProgressBar} />
          <LoadingBox style={styles.loadingBoxProgressBar} />
          <LoadingBox style={styles.loadingBoxProgressBar} />
          <LoadingBox style={styles.loadingBoxLast} />
        </View>
      </Gutter>
    </View>
  );
};
